import React from 'react';
import './style.css';

const FeatureCards = ({ items = [], className = '', onNavigate }) => {
    if (!items.length) {
        return null;
    }

    const columnClass = items.length <= 2
        ? 'col-12 col-md-6 mb-3'
        : items.length === 4
            ? 'col-6 col-lg-3 mb-3'
            : 'col-12 col-md-4 mb-3';

    return (
        <div className={`feature-cards row ${className}`.trim()}>
            {items.map((item) => (
                <div className={columnClass} key={item.title}>
                    <article className="feature-card">
                        <h3 className="feature-card-title">{item.title}</h3>
                        <p className="feature-card-text">{item.description}</p>
                        {item.cta && item.id && (
                            <a
                                className="feature-card-cta"
                                href={`#${item.id}`}
                                onClick={(event) => {
                                    if (onNavigate) {
                                        onNavigate(event, item.id);
                                    }
                                }}
                            >
                                {item.cta}
                            </a>
                        )}
                    </article>
                </div>
            ))}
        </div>
    );
};

export default FeatureCards;
